const convertStringToCamelCase = (value: string): string => {
  return value
    .split('_')
    .map((word, index) => {
      if (index === 0) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')
}

const convertObjectKeysToCamelCase = (obj: any): any => {
  const newObj: any = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = isCamelCase(key) ? key : convertStringToCamelCase(key)
      if (obj[key] !== null && typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
        if (Array.isArray(obj[key])) {
          // If the value is an array, map over it and convert any objects inside it
          newObj[newKey] = obj[key].map((item: any) => {
            if (typeof item === 'object') {
              return convertObjectKeysToCamelCase(item)
            } else {
              return item
            }
          })
        } else {
          // If the value is an object, recursively convert its keys
          newObj[newKey] = convertObjectKeysToCamelCase(obj[key])
        }
      } else {
        newObj[newKey] = obj[key]
      }
    }
  }
  return newObj
}

const convertStringToSnakeCase = (value: string): string => {
  const nameArray = value.split('')
  const snakeCaseName = nameArray.map((name, index) => {
    if (index === 0) {
      return name
    }
    if (name === name.toUpperCase()) {
      return '_' + name.toLowerCase()
    }
    return name
  })
  return snakeCaseName.join('')
}

const convertObjectKeysToSnakeCase = (obj: any): any => {
  const newObj: any = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = isSnakeCase(key) ? key : convertStringToSnakeCase(key)
      if (obj[key] !== null && typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
        if (Array.isArray(obj[key])) {
          // If the value is an array, map over it and convert any objects inside it
          newObj[newKey] = obj[key].map((item: any) => {
            if (typeof item === 'object') {
              return convertObjectKeysToSnakeCase(item)
            } else {
              return item
            }
          })
        } else {
          // If the value is an object, recursively convert its keys
          newObj[newKey] = convertObjectKeysToSnakeCase(obj[key])
        }
      } else {
        newObj[newKey] = obj[key]
      }
    }
  }
  return newObj
}

const isSnakeCase = (str: string): boolean => {
  return /^[a-z0-9_]+$/.test(str)
}

const isCamelCase = (str: string): boolean => {
  return /^[a-z][a-zA-Z]*$/.test(str) && /[A-Z]/.test(str)
}

export { convertStringToCamelCase, convertObjectKeysToCamelCase, convertStringToSnakeCase, convertObjectKeysToSnakeCase }
